export const currencyFormat = (value: number, withDecimal: boolean = true) => {
  const formatter = new Intl.NumberFormat("en-PH", {
    currency: "PHP",
    currencyDisplay: "symbol",
    minimumFractionDigits: withDecimal ? 2 : 0,
    style: "currency"
  });

  return formatter.format(value);
};
